import React, { memo } from "react";
import clsx from "clsx";
import Icon from "../../../../shared-components/css-modules/lexus/atoms/Icon";
import { CarConfigConfigureSectionsLbx } from "../../../utils/types/SectionTypesLbx";
import Cta from "../common/header/Cta";
import baseConfigStyles from "../Carconfig.module.scss";
import styles from "../common/navigation/Navigation.module.scss";
import Carousel from "../../../../shared-components/css-modules/lexus/vendor/carousel/Carousel";
import { ScrollMethod } from "../../../../../../common-deprecated/hooks/useScrollSnap";
import type { sectionsWithoutWelcome } from "./ConfigureNavigationButton";
import ConfigureNavigationButton from "./ConfigureNavigationButton";
import a11y from "../../../../shared-components/css-modules/lexus/utils/Accessibility.module.scss";
import { CarConfigLabel, useCarConfigLabel } from "../../../utils/labelUtils";

export type ConfigureNavigationType = {
    activeSection: CarConfigConfigureSectionsLbx;
    sections: CarConfigConfigureSectionsLbx[];
};

const ConfigureNavigation = (props: ConfigureNavigationType): JSX.Element => {
    const { sections, activeSection } = props;

    const navigationLabel = useCarConfigLabel("carConfigA11yNavAnchor");

    return (
        <div
            className={clsx(styles.wrapper, activeSection !== CarConfigConfigureSectionsLbx.Summary && styles.visible)}
        >
            <nav className={styles.nav} aria-label={navigationLabel} id="step-navigation">
                <Carousel>
                    <Carousel.Trigger direction="left" className={clsx(styles["scroll-indicator"], styles.left)}>
                        <Icon variant="chevron-left" sizing="md" aria-hidden="true" />
                        <span className={a11y["sr-only"]}>
                            <CarConfigLabel label="carConfigA11ySliderMoveStart" />
                        </span>
                    </Carousel.Trigger>
                    <Carousel.Track itemCount={sections.length} scrollMethod={ScrollMethod.Full}>
                        {sections
                            // No navigation element is required for the atmosphereWelcome "step"
                            .filter((section) => section !== CarConfigConfigureSectionsLbx.AtmosphereWelcome)
                            .map((section, index) => (
                                <ConfigureNavigationButton
                                    key={section}
                                    section={section as sectionsWithoutWelcome}
                                    index={index}
                                />
                            ))}
                    </Carousel.Track>
                    <Carousel.Trigger direction="right" className={clsx(styles["scroll-indicator"], styles.right)}>
                        <Icon variant="chevron-right" sizing="md" aria-hidden="true" />
                        <span className={a11y["sr-only"]}>
                            <CarConfigLabel label="carConfigA11ySliderMoveEnd" />
                        </span>
                    </Carousel.Trigger>
                </Carousel>
            </nav>
            <div className={baseConfigStyles.cta}>
                <Cta />
            </div>
        </div>
    );
};

export default memo(ConfigureNavigation);
